import React from "react";

const data = [
  {
    title: "📚 Content",
    items: [
      "🎓 Modern Learning",
      "🛠️ Skill Development",
      "⚡ MSME & General Productivity",
      "🔧 Utilities",
      "📊 Six Sigma Tools",
      "🌱 Personal Development",
      "🏠 Home Management",
      "🧑‍🏫 Modern Teaching Tools",
      "🧠 DeepThinking Workflow", 
      "🌿 Environment Sustainability Practices",           
      "🤖 AI Tools",
      "🔗 AI Integration",
      "❤️ Health Management Tools",
      "🧬 Digital Twin",
      "🌐 Metaverse",
      "🏷️ Talking Label",
      "🔁 Growth Loop",
      "🎉 Event Management",
      "💳 Digital Cards",
      "💡 Digital Earning Framework",
      "💼 Job Board",
      "🇮🇳 India Youth Job Creation",
      "🌍 Global Youth Job Creation",
      "👨‍💼 Employee Productivity",
      "🏢 ERP Systems",
      "🚀 Agile Project Management",
      "🏆 Ranking & Rewards",
      "🔔 User Engagement",
      "✍️ Author & Publisher Engagement",
      "💰 Kharcho Jeeto",
      "📸 Photo Can Win",
      "📊 Marksheet Contest",
      "🥔 Aalu Dalo Sona Nikalo Contest",
      "🤝 Social Welfare Hooks",
      "🧮 Calculator",
      "📩 Invitation & Presentation Tool",
      "🏅 RANKR Test Series",
    ],
  },
  {
    title: "👥 Community",
    items: [
      "🏪 MSME Owners",
      "👩 Women",
      "🤝 SHGs (Self Help Groups)",
      "🚜 Farmers",
      "🧑‍🏭 Blue Collar Workers",
      "🎓 Students",
      "🏡 Housewives",
      "👨‍👩‍👧 Families",
      "🍎 Teachers",
      "🏫 Institutions",
      "🏛️ Government",
      "👔 Professionals",
      "🏢 Corporates",
      "🧑 Youth",
      "👩‍👧 Preschooler Mothers",
      "🏘️ Housing Societies",
      "🚶 Commuters",
      "🏥 Health Sector",
      "⚽ Sports Community",
      "🍽️ HORECA",
      "🧑‍🔧 Contractors",
      "🎓 Higher Education Students",
      "🏛️ Government Officers",
    ],
  },
  {
    title: "💰 Commerce",
    items: [
      "🌐 Immersive Digital Learning",
      "📈 Productivity Toolkit Subscription",
      "🧠 Self-Management Toolkit Subscription",
      "🧑‍💼 Managed Services",
      "💼 Digital Commerce Commission",
      "💸 Referral Commissions",
      "📢 Ad Revenue",
      "🏷️ White Labeling Platform",
      "🔌 Microservices / APIs",
      "💳 AI Subscription",
      "🧑‍⚕️ AI Counselling",
      "🧑‍💼 Counselling & Consulting",
      "🎓 Certified Resource Training",
      "📝 Test Series Sales",
      "🩺 Health Management Self-Service",
      "👑 Royalty Income",
    ],
  },
];

const CCC = () => {
  return (
    <div className="bg-black text-white [&_p]:text-white [&_li]:text-white min-h-screen p-2">
      <h1 className="text-lg lg:text-xl font-bold text-center text-yellow-200">⚡ Content • Community • Commerce</h1>
      <h2 className="text-xs lg:text-sm font-bold mb-4 text-center text-cyan-200">Think5Whys - A Unified Platform for Content, Community & Commerce at Global Scale.</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {data.map((section, index) => (
          <div
            key={index}
            className="border border-gray-700 rounded-xl p-4 shadow-md"
          >
            <h2 className="text-lg text-cyan-400 font-semibold mb-3">
              {section.title}
            </h2>

            <ul className="space-y-2 text-sm">
              {section.items.map((item, i) => (
                <li key={i} className="border-b border-gray-800 pb-1">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CCC;